import React from 'react';

import logoBlue from '../../assets/logo-blue.png';
import logoInk from '../../assets/logo-ink.png';
import logoNeon from '../../assets/logo-neon-tagline.png';
import markBlue from '../../assets/mark-blue.png';
import markInk from '../../assets/mark-ink.png';
import markWhite from '../../assets/mark-white.png';
import markNeon from '../../assets/mark-neon.png';
import logoBuild from '../../assets/logo-build.png';
import logoSecure from '../../assets/logo-secure.png';
import logoSupport from '../../assets/logo-support.png';

/**
 * Brandmark and lockup renderer. Never redraw the mark — always the supplied art.
 *
 * VENDORED CHANGE: upstream resolves images from a runtime `basePath` string.
 * Here they are imported so the bundler fingerprints and emits them, which means
 * no broken images if the app is served from a sub-path and proper cache-busting
 * on redeploy. `basePath` is accepted and ignored for API compatibility.
 */
const FILES = {
  full: { blue: logoBlue, ink: logoInk, neon: logoNeon },
  mark: { blue: markBlue, ink: markInk, white: markWhite, neon: markNeon },
  build: logoBuild,
  secure: logoSecure,
  support: logoSupport,
};

export function Logo({
  kind = 'full',
  color = 'blue',
  line,
  height = 40,
  basePath, // eslint-disable-line no-unused-vars -- accepted for upstream API parity
  style,
  alt,
  ...rest
}) {
  let src;
  if (line) src = FILES[line];
  else if (kind === 'mark') src = FILES.mark[color] || FILES.mark.blue;
  else src = FILES.full[color] || FILES.full.blue;

  return (
    <img
      src={src}
      alt={alt || (line ? `Y365 ${line}` : 'Y365 — Your IT partner')}
      style={{ height, width: 'auto', display: 'block', ...style }}
      {...rest}
    />
  );
}
